import { Link } from 'react-router-dom'
import { handleImageError } from '../../utils/imageUtils'
import { formatFinderId, pluralize } from '../../utils/formatUtils'
import useProductCategories from '../../hooks/useProductCategories'
import DisplayBidStatus from '../common/DisplayBidStatus'

const RequestSummaryCard = ({ request }) => {
  const { getCategoryNameById } = useProductCategories()
  const finderId = formatFinderId(request?.id)

  if (!request?.id) {
    console.warn('RequestSummaryCard rendered without a valid request ID.')
    return null
  }

  return (
    <Link
      to={`/bids/${request.id}`}
      className="block hover:bg-neutral-200-50 transition-colors duration-150 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tertiary-600"
    >
      <div className="flex items-center gap-3 p-3 bg-background border border-secondary-600/30 rounded-md shadow-sm relative">
        <div className="flex-shrink-0 w-[75px] h-[75px]">
          <img
            src={request?.imageUrl || '/placeholder-image.png'}
            alt={getCategoryNameById(request.productFinderCategoryId)}
            className="w-full h-full object-cover rounded-md bg-neutral-200-100"
            onError={handleImageError}
          />
        </div>

        <div className="flex-grow min-w-0 relative">
          <span className="absolute top-0 right-0 text-sm italic font-medium text-secondary-600">
            {finderId}
          </span>
          <h3 className="text-md font-medium text-gray-700 truncate pr-20">
            {getCategoryNameById(request.productFinderCategoryId)}
          </h3>
          <p className="text-sm text-gray-500">
            {request?.productFinderDescription
              ? request?.productFinderDescription.substring(0, 30) +
                (request?.productFinderDescription.length > 30 ? '...' : '')
              : 'Request'}
          </p>
          <DisplayBidStatus isOpen={request.isOpen} expiresAt={request.expiresAt} />
          <p className="mt-2 text-sm font-bold text-tertiary-600 capitalize">
            {request?.responseCount > 0
              ? `${request?.responseCount} ${pluralize('response', request?.responseCount)}`
              : 'No responses'}
          </p>
        </div>
      </div>
    </Link>
  )
}

export default RequestSummaryCard
